import apiFetch from 'api/base'
import { AxiosPromise } from 'axios'

const URL = `/static/timezones`

const getTimezones = (): AxiosPromise => apiFetch(URL)

export default getTimezones
